import { Flex, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import { LoanProduct } from '@finley-technologies/finley-types';

import { CreditAgreement } from '../common';

type LoanProductEntityProps = {
  loanProductEntity: LoanProduct.LoanProductWithLoanTapeType;
  config?: CreditAgreement.Config.LoanProductMechanics.Config;
};
export const LoanProductEntity = ({
  loanProductEntity,
  config,
}: LoanProductEntityProps) => {
  return (
    <>
      <Flex alignItems="center" mb="10px">
        <Text fontSize="20px" fontWeight="bold">
          Entity
        </Text>
      </Flex>
      <Flex mb="35px" width="100%" overflowY="auto">
        <Table borderWidth="1px">
          <Thead>
            <Tr>
              <Th minWidth="15rem">Name</Th>
              <Th minWidth="10rem">Type</Th>
              {config && <Th minWidth="12rem">External Receivable ID</Th>}
              {loanProductEntity.loanTapeType === 'preassignedMasterLoanTape' &&
                config && (
                  <>
                    <Th minWidth="14rem">Signaled Assignment Field</Th>
                    <Th minWidth="14rem">Signaled Assignment Value</Th>
                  </>
                )}
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>{loanProductEntity.name}</Td>
              <Td>
                {commonUtils.toSentenceCase(loanProductEntity.loanTapeType)}
              </Td>
              {config && <Td>{config.externalReceivableIdField || '-'}</Td>}
              {loanProductEntity.loanTapeType === 'preassignedMasterLoanTape' &&
                config && (
                  <>
                    <Td>
                      {
                        config.signaledExternalAssignment
                          ?.signaledExternalAssignmentField
                      }
                    </Td>
                    <Td>
                      {
                        config.signaledExternalAssignment
                          ?.signaledExternalAssignment
                      }
                    </Td>
                  </>
                )}
            </Tr>
          </Tbody>
        </Table>
      </Flex>
    </>
  );
};
